module.exports = __webpack_public_path__ + "static/media/COALINDIA.b28247f4.txt";